import { useState } from "react";
import { Flame, Snowflake, TrendingUp } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useSlip } from "@/context/SlipContext";

const MODES = {
  heaters: { label: "Ride the heaters", Icon: Flame, cls: "border-orange-400/70 bg-orange-500/20 text-orange-200 hover:bg-orange-500/30", need: "Need at least 2 picks backing hot teams", title: "Build a parlay from picks backing hot teams" },
  slumps: { label: "Fade the slumps", Icon: Snowflake, cls: "border-sky-400/70 bg-sky-500/20 text-sky-200 hover:bg-sky-500/30", need: "Need at least 2 picks against cold teams", title: "Build a parlay from picks against cold teams" },
  trends: { label: "Trend stack", Icon: TrendingUp, cls: "border-emerald-400/70 bg-emerald-500/20 text-emerald-200 hover:bg-emerald-500/30", need: "Need at least 2 picks with a strong season trend", title: "Stack the strongest trend chips: 60%+ covers / favorite-dog records, 70%+ overs-unders" },
};

export function FormParlayButton({ mode = "heaters", count, className = "" }) {
  const { replace } = useSlip();
  const [busy, setBusy] = useState(false);
  const m = MODES[mode];
  const build = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/parlays/${mode}`);
      replace(data.legs, { title: data.title, strategy: data.strategy });
      toast.success(`"${data.title}" loaded — ${data.legs.length} legs from ${data.available} ${mode === "heaters" ? "hot-team" : mode === "slumps" ? "cold-team" : "strong-trend"} picks`);
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <button data-testid={`${mode}-parlay-btn`} onClick={build} disabled={busy || (count != null && count < 2)} title={count != null && count < 2 ? m.need : m.title}
      className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-xs font-bold uppercase tracking-wider transition-[background-color,transform] duration-200 hover:-translate-y-0.5 disabled:opacity-50 disabled:hover:translate-y-0 ${m.cls} ${className}`}>
      <m.Icon size={12} /> {busy ? "Building…" : m.label}
    </button>
  );
}

export const HeatersButton = (props) => <FormParlayButton mode="heaters" {...props} />;
export const SlumpsButton = (props) => <FormParlayButton mode="slumps" {...props} />;
export const TrendsButton = (props) => <FormParlayButton mode="trends" {...props} />;
